import { HttpClient } from '@angular/common/http';
import {
    ChangeDetectionStrategy,
    ChangeDetectorRef,
    Component,
} from '@angular/core';
import { ActivatedRoute } from '@angular/router';
import { Observable } from 'rxjs';
import { filter, map, switchMap, withLatestFrom } from 'rxjs/operators';
import { FolderService } from 'src/app/acl-data/folder/folder.service';
import { environment } from 'src/environments/environment';

@Component({
    templateUrl: './reports-parameters.component.html',
    styleUrls: ['./reports-parameters.component.scss'],
    changeDetection: ChangeDetectionStrategy.OnPush,
})
export class ReportsParametersComponent {
    data$ = this.route.data as Observable<any>;

    loading$ = this.folderService.loading$;

    public reportRoot = environment.reportRoot;
    public reportLimit = environment.limitReportLibrary;

    reportParameters$ = this.data$.pipe(
        map(v => (v && v.custom ? v.custom.reportParameters : undefined))
    );

    libraryLimit$ = this.data$.pipe(
        map(v =>
            v && v.custom && v.custom.unlimitedLibrary
                ? undefined
                : this.reportLimit
        )
    );

    sortOrder$ = this.data$.pipe(
        map(v => (v && v.custom ? v.custom.sortOrder : undefined))
    );

    reportDescription$ = this.data$.pipe(
        map(v => (v && v.custom ? v.custom.reportDescription : undefined))
    );

    // http: //localhost:9080/ACLReports/v1/ACLReports/NoAlertRequiredReport?ObjectStore=ACL2&Library=Argentina - Aspen Argentina S A

    objectStore$ = this.route.data.pipe(
        map(routeValue =>
            routeValue.custom.subReport
                ? routeValue.parentMenu.data.parentMenu.data.parentMenu.data.id
                : routeValue.parentMenu.data.parentMenu.data.id
        )
    );

    // libraries$ = this.objectStore$.pipe(
    //     filter(v => !!v),
    //     switchMap(v => this.folderService.getRoot(v))
    // );

    // categories$ = this.libraries$.pipe(
    //     // map(v => v.reduce((acc, row) => [...acc, ...row.subFolders], [])),
    //     map(v => {
    //         if (!v[0]) {
    //             return [];
    //         }

    //         let results = [];

    //         const notTrx = v.find(
    //             r => r.propertiesObj.PathName !== '/Transactions'
    //         );

    //         if (!!notTrx) {
    //             results = [...results, ...notTrx.subFolders];
    //         }
    //         const transactionLibrary = v.find(
    //             r => r.propertiesObj.PathName === '/Transactions'
    //         );
    //         if (!!transactionLibrary) {
    //             results = [...results, ...transactionLibrary.subFolders];
    //         }
    //         // console.log('RESULTS', results);
    //         return results;
    //     }), // 1st Real folder
    //     withLatestFrom(this.objectStore$),
    //     switchMap(([ids, os]) =>
    //         this.folderService.getByIds(os, ids).pipe(
    //             map(v =>
    //                 v.filter(
    //                     row =>
    //                         row.propertiesObj.ClassDescription ===
    //                             'CategoryFolder' ||
    //                         row.propertiesObj.ClassDescription ===
    //                             'LibraryFolder'
    //                 )
    //             ),
    //             map(v =>
    //                 v.sort((a, b) =>
    //                     a.propertiesObj.FolderName > b.propertiesObj.FolderName
    //                         ? 1
    //                         : -1
    //                 )
    //             )
    //         )
    //     )
    // );

    library: string;
    territory: string;
    category: string;
    dateFrom: Date;
    dateTo: Date;
    notificationList: number[];
    deletedReason: number[];
    businessOwner: number;
    typeOfAccess: string;
    userEnabled: boolean;

    productList: number[];
    moleculeList: number[];
    territoryList: number[];
    userList: string[];
    uPI: string;
    ContractIdentifier: string;

    boSearch = '';
    downloading = false;
    downloadError = false;

    constructor(
        private route: ActivatedRoute,
        private folderService: FolderService,
        private httpClient: HttpClient,
        private cdr: ChangeDetectorRef
    ) {}

    noParameters = () => {
        return (
            !this.library &&
            !this.category &&
            !this.territory &&
            !this.dateFrom &&
            !this.dateTo &&
            !this.deletedReason &&
            !this.notificationList &&
            !this.productList &&
            !this.moleculeList &&
            !this.territoryList &&
            !this.uPI &&
            !this.businessOwner &&
            !this.ContractIdentifier &&
            !this.userList
        );
    };

    getQueryParms = () => {
        let result = '';

        if (this.library) {
            result += `&Library=${this.library}`;
        }

        if (this.category) {
            result += `&Category=${this.category}`;
        }

        if (this.territory) {
            result += `&Territory=${this.territory}`;
        }

        if (this.dateFrom) {
            result += `&DateFrom=${this.dateFrom.getTime()}`;
        }

        if (this.dateTo) {
            result += `&DateTo=${this.dateTo.getTime()}`;
        }

        if (this.typeOfAccess) {
            result += `&TypeOfAccess=${this.typeOfAccess}`;
        }

        if (this.userEnabled) {
            result += `&UserEnabled=${this.userEnabled}`;
        }

        if (this.deletedReason) {
            let reason = this.deletedReason.reduce(
                (acc, row) => `${acc}${row},`,
                ''
            );
            reason = reason.substr(0, reason.length - 1);

            result += `&DeleteReason=${reason}`;
        }

        if (!!this.notificationList && this.notificationList.length >= 0) {
            result += `&NotificationTypeList=${this.notificationList.reduce(
                (acc, row) => `${acc}${row},`,
                ''
            )}`;
        }

        if (!!this.productList && this.productList.length >= 0) {
            result += `&ProductList=${this.productList.reduce(
                (acc, row) => `${acc}${row},`,
                ''
            )}`;
        }

        if (!!this.moleculeList && this.moleculeList.length >= 0) {
            result += `&MoleculeList=${this.moleculeList.reduce(
                (acc, row) => `${acc}${row},`,
                ''
            )}`;
        }

        if (!!this.territoryList && this.territoryList.length >= 0) {
            result += `&TerritoryList=${this.territoryList.reduce(
                (acc, row) => `${acc}${row},`,
                ''
            )}`;
        }

        if (!!this.userList && this.userList.length >= 0) {
            result += `&Users=${this.userList.reduce(
                (acc, row) => `${acc}${row},`,
                ''
            )}`;
        }

        if (!!this.uPI) {
            result += `&UPI=${this.uPI}`;
        }

        if (!!this.ContractIdentifier) {
            result += `&ContractIdentifier=${this.ContractIdentifier}`;
        }

        if (!!this.businessOwner) {
            result += `&BusinessOwnerID=${this.businessOwner}`;
        }
        return result;
    };

    getReport = (
        disabled: boolean,
        path: string,
        objectStore: string,
        filename: string
    ) => {
        console.log('Get Report', disabled);
        if (disabled) {
            return;
        }
        this.downloading = true;
        this.downloadError = false;

        this.sortOrder$
            .pipe(
                switchMap(sortOrder =>
                    this.httpClient.post(
                        `${
                            this.reportRoot
                        }${path}?ObjectStore=${objectStore}${this.getQueryParms()}`,
                        null,
                        {
                            responseType: 'arraybuffer',
                            headers: {
                                Accept:
                                    'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                            },
                            params: {
                                Sort: sortOrder.reduce(
                                    (row, acc) => `${row}${acc},`,
                                    ''
                                ),
                            },
                        }
                    )
                )
            )
            .subscribe(
                response => {
                    this.downloading = false;
                    this.cdr.detectChanges();
                    this.downLoadFile(
                        response,
                        'application/vnd.openxmlformats-officedocument.spreadsheetml.sheet',
                        filename
                    );
                },
                error => {
                    this.downloading = false;
                    this.downloadError = true;
                    this.cdr.detectChanges();
                }
            );
    };

    /**
     * Method is use to download file.
     * @param data - Array Buffer data
     * @param type - type of the document.
     */
    downLoadFile(data: any, typeValue: string, filename: string) {
        console.log('Download Data');
        // const blob = new Blob([data], { type: typeValue });
        // const url = window.URL.createObjectURL(blob);
        // window.location.href = url;

        const a = document.createElement('a');
        document.body.appendChild(a);
        // a.style = 'display: none';

        const blob = new Blob([data], { type: typeValue });
        const url = window.URL.createObjectURL(blob);
        a.href = url;
        a.download = filename;
        a.click();
        window.URL.revokeObjectURL(url);
        // const pwa = window.open(url);
        // if (!pwa || pwa.closed || typeof pwa.closed == 'undefined') {
        //     alert('Please disable your Pop-up blocker and try again.');
        // }
    }
}
